import { __rest, __assign } from 'tslib';
import React, { useState, useEffect } from 'react';
import { SuccessDoneIcon, ExclamationCircleIcon } from '@panwds/icons';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/FaIcon.esm.js';
import { LoadingIconFull } from '../Icon/SemanticIcons.esm.js';
import { Button } from './Button.esm.js';

function Message(_a) {
    var success = _a.success, message = _a.message, size = _a.size;
    var messageStyle = success ? "tw-text-risk-2" : "tw-text-red";
    var textSize = size === "lg" ? "tw-text-sm" : "tw-text-xs";
    var defaultClassNames = classNames(messageStyle, textSize);
    return (React.createElement("div", { className: "tw-flex tw-space-x-1 tw-items-center ".concat(defaultClassNames) },
        success ? (React.createElement(SuccessDoneIcon, { size: "lg" })) : (React.createElement(ExclamationCircleIcon, { size: "lg" })),
        React.createElement("span", { className: success ? "tw-animate-fadeIn" : "" }, message)));
}
function LoadingButton(_a) {
    var children = _a.children, onClickCallback = _a.onClickCallback, dataResult = _a.dataResult, appearance = _a.appearance, disabled = _a.disabled, size = _a.size, addClassName = _a.addClassName, type = _a.type, passThrough = __rest(_a, ["children", "onClickCallback", "dataResult", "appearance", "disabled", "size", "addClassName", "type"]);
    var loading = dataResult.loading, success = dataResult.success, message = dataResult.message;
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), isSuccessful = _c[0], setIsSuccessful = _c[1];
    var handleClick = function () {
        onClickCallback && onClickCallback();
    };
    useEffect(function () {
        setIsLoading(loading);
        setIsSuccessful(success);
    }, [dataResult]);
    var msg = message ? (React.createElement(Message, { message: message, success: isSuccessful, size: size })) : ("");
    return (React.createElement("div", { className: "tw-flex tw-space-x-2" },
        React.createElement(Button, __assign({ onClick: handleClick, appearance: appearance, isLoading: isLoading, disabled: disabled, size: size, addClassName: addClassName, type: type }, passThrough),
            React.createElement(LoadingIconFull, { addClassName: classNames("tw-absolute ".concat(isLoading ? "tw-opacity-100" : "tw-opacity-0", " ")), size: "md" }),
            React.createElement("span", { className: isLoading ? "tw-opacity-0" : "tw-opacity-100" }, children)),
        msg));
}

export { LoadingButton, Message };
//# sourceMappingURL=LoadingButton.esm.js.map
